;
(function(global, document, $) {

  require('./index.css');

  var COOKIE_CONFIG = {
    domain: 'tq.qq.com',
    path: '/',
    expires: 24 * 60 * 60
  };

  function isQQBrowser() {

    return (!/Trident/i.test(navigator.userAgent) &&
      /QQBrowser/i.test(navigator.userAgent) && chrome &&
      window.external && window.external.getVersion) ? true : false

  }

  // 初始化登录&用户信息UI
  function initLoginUI(option) {

    var showAvatar = false;
    var loginUIHtml = {
      notLogin: '你好，<a href="#" class="bt_login">请登录</a>',
      isLogin: '<span class="user_nick" title="欢迎">{nick}</span><a id="header-logout" class="mod_st_logout" href="#" title="退出">退出</a>',
      isLoginIcon: '<img class="user_icon" src="{avatar}"/><span class="user_nick">{nick}</span><a id="header-logout" class="mod_st_logout" href="#" title="退出">退出</a>'
    };

    // 绑定登录事件
    var _setLogin = function(option) {
      showAvatar = !!option.showAvatar;
      // 登录
      qq.login.bind('login', function() {
        var _uin = qv.cookie.get('_uin');
        var _nick = qv.cookie.get('_nick');
        var _avatar = qv.cookie.get('_avctar');
        // 如果cookie里有_uin，_nick等信息，更新，否则去；拉取
        if (_uin === qq.login.getUin() && _nick && _avatar) {
          _fillUserInfo(_nick, _avatar);
        } else {
          var options = {
            url: 'http://iyouxi3.vip.qq.com/ams3.0.php',
            dataType: 'jsonp',
            data: {
              _c: 'User',
              field: "uin,nickname,faceurl",
              g_tk: qq.security.getCSRFToken()
            },
            success: function(res, textStatus, jqXHR) {
              qv.cookie.set('_uin', res.data.uin, COOKIE_CONFIG);
              qv.cookie.set('_nick', res.data.nickname, COOKIE_CONFIG);
              qv.cookie.set('_avctar', res.data.faceurl, COOKIE_CONFIG);
              _fillUserInfo(res.data.nickname, res.data.faceurl);
              if (res.data.nickname === undefined) {
                qq.login.logout();
              }
            }
          };
          $.ajax(options);
        }
      });
      // 退出登录
      qq.login.bind('logout', function() {
        pt.logout();
        qv.cookie.clear('_uin');
        qv.cookie.clear('_nick');
        qv.cookie.clear('_avctar');
        _fillUserInfo();
      });
      if (qq.login.getUin()) {
        qq.login.trigger('login');
      } else {
        _fillUserInfo();
      }
    }

    // 设置用户信息到dom
    var _fillUserInfo = function(nick, faceurl) {
      var _arHtml = [];
      var _data = {};
      if (nick) {
        _data.nick = qv.string.encodeHTML(nick);
      }
      if (faceurl) {
        _data.avatar = faceurl;
      }
      if (!qq.login.getUin()) {
        _arHtml.push(loginUIHtml.notLogin);
      } else {
        if (showAvatar) {
          _arHtml.push(qv.string.format(loginUIHtml.isLoginIcon, _data));
        } else {
          _arHtml.push(qv.string.format(loginUIHtml.isLogin, _data));
        }
      }
      $('#navUserInfo').html(_arHtml.join(''));
      if (showAvatar) {
        $('#navUserInfo .user_icon').show();
      }
      _bindEvent();
    };
    // events: 登录 | 退出登录
    var _bindEvent = function() {
      $('.bt_login').click(function(e) {
        e.preventDefault();
        pt.showPtui();
      });
      $('.mod_st_logout').click(function(e) {
        e.preventDefault();
        qq.login.logout();
      });
      qq.login.trigger('navrendered');
    }

    qq.login.open = function() {
      pt.showPtui();
    }
    _setLogin(option);

  }

  // 加载&初始化登录组件ptlogin
  function initPtlogin(option) {

    var ptloginParam = {
      'appid': 1600000073,
      'daid': 5,
      's_url': location.href,
      'style': 20,
      'protocol': 'https:',
      'domain': 'qq.com',
      'border_radius': 1,
      'target': 'top',
      'maskOpacity': 40
    };
    if (typeof option === 'object' && option.qzoneDaid) {
      ptloginParam['daid'] = 5;
    }
    $.getScript('https://xui.ptlogin2.qq.com/js/ptlogin_v1.js', function() {
      pt.setParams(ptloginParam);
    });

  }

  // header初始化
  function initHeader(option) {

    // 加载&初始化登录组件ptlogin
    initPtlogin(option);
    initLoginUI(option);

    // 加载页头UI
    // var headerClass = option.isWhiteStyle ? '' : 'black';
    var $headerQBEle = $('#headerQB');
    // $('#modHeader div.mod-act-header').addClass(headerClass);

    // 非QB显示下载按钮
    if (!isQQBrowser()) {
      $headerQBEle.css('display', 'inline');
    }
    if (typeof option === 'object') {
      $headerQBEle.attr('href', (option.downloadLink || 'http://dldir1.qq.com/invc/tt/QQBrowser_Setup_Privilegecenter.exe'));
      if (option.report) {
        $headerQBEle.onclick = function() {
          _qblog.tcss.click(option.report)
        }
      }
    }

  }

  initHeader({
    // 是否白色背景风格 false黑色|true白色（可选，默认false）
    // isWhiteStyle: true,
    // 用户头像是否显示（可选，默认false）
    showAvatar: true,
    // 下载QB按钮的链接 默认：特权中心QB包（可选）
    downloadLink: 'http://dldir1.qq.com/invc/tt/QQBrowser_Setup_Privilegecenter.exe',
    // 点击流数据上报（可选）
    report: 'BROWSER.EVENTS.TOPQBDOWNLOADCLICK',
  });

})(this, document, jQuery);


// WEBPACK FOOTER //
// ../node_modules/@tencent/pcqb-act-header/src/index.js